import { atom } from 'jotai';

import { FourProperty } from '@/hooks/four/useFourProperties';

export const fourPropertiesAtom = atom<FourProperty[]>([]);
export const selectedFourPropetyAtom = atom<FourProperty | null>(null);
export const hoveredFourPropetyAtom = atom<FourProperty | null>(null);
